export default __webpack_public_path__ + "media/images/banner/banner-38-b964fca13677b25af25552b9798db2ea.jpg";